export default "__VITE_ASSET__497964ae__"